import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SharedService } from '../Services/shared.service';
import { Subject, Subscription, ValueFromArray, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PAGE, SECTION, VALIDATION, WIDGET } from '../../models/app-json';
import { CATEGORIES_META_DATA} from '../../constants/widgets_meta_config_cnsts';
import { CdkDragDrop, CdkDragEnter, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router';
import { PAGEI } from '../../models/page_config_json';
import { trigger, transition, style,animate } from '@angular/animations';
import { DEFAULT_BLANK_PAGE, PAGE_TYPE_MAPPING } from '../../constants/proj.cnst';


@Component({
  selector: 'lib-sidenav-content-list',
  templateUrl: './sidenav-content-list.component.html',
  styleUrls: ['./sidenav-content-list.component.scss'],
  animations: [
    trigger('sidenavFadInOut', [
      transition(':enter', [
        style({opacity: 0,transform: 'translateX(-100px)'}),
        animate('200ms', style({ opacity: 1,transform: 'translateX(0px)' })),
      ]),
      transition(':leave', [
        style({opacity: 1, transform: 'translateX(0px)'}),
        animate('200ms', style({ opacity: 0,transform: 'translateX(-100px)' }))
      ])
    ]),
  ]

})
export class SidenavContentListComponent implements OnInit,OnDestroy {
  openedContainers: string[] = [];
  page: PAGE = {pageID:"",pageName:"",section:[]};
  pageData!: PAGEI;
  displayedContent!: string;
  sideNavSubscription: Subscription[] = [];
  displaySubNav: boolean = false;
  colorCtr!: FormGroup;
  panelOpenState = true;
  buttonActions = ["default action","conditional action","Api call"]
  selectedActions:string[] = []
  componentOptions: string[] = ['button', "simple list", "navigation"];
  selectedComponents:SECTION[] = [];
  selectedValidationType!: string;
  validationValue!: string;
  inputFieldValidationData = ['Required', 'MinLength', 'MaxLength'];
  selectedWidgetTypeConfig!: string;
  isRequiredFormValidation: boolean = false;
  validationForm!: FormGroup;
  selectedWidgetMetaData: any = {}
  selectedColor!:string;
  selectedBgColor!:string;
  openedWidgetForm!:number;
  isClicked:boolean = false;
  categoriesList: { type: string, items: (WIDGET|SECTION)[]}[] = CATEGORIES_META_DATA;
  searchTerm: string = '';
  // filteredCategories:  { type: string, items: (WIDGET|SECTION)[]}[] = CATEGORIES_META_DATA;
  // filteredDefaultPageTemplate :any = DEFAULT_PAGE_TEMPALTES_DATA
  pageTypeMapping:any=PAGE_TYPE_MAPPING;
  filteredDefaultPageTemplate:any;
  panelStates: boolean[] = [true, false, false, false, false];
  isFilterApplied: boolean = false;
  selectedSectionData:SECTION = {sectionId:"", key:'',name:"",image:"",widgets:[],isEditable:true,showDeleteButton:true,sectionType:''};
  widgetId:any;
  sectionIndex:any;
  defPagesData:any=[];
  widgetIndex:any;
  applicationMetaData:any;
  stageName!:string;
  @Output() onDrop = new EventEmitter<any>();
  @Input() filteredCategories: any
  trackByFn(index: any, item: any): any {
    return item;
  }
  drop(event: any) {
    const droppedItem = event.item.data;
    if(!droppedItem?.applicationId && !droppedItem?.formId){
      this.onDrop.emit(event);
    }
  }
    private destroy$ = new Subject<void>();
  constructor(private sharedService: SharedService,private route: ActivatedRoute, private router: Router,private _formBuilder:FormBuilder,
    private cdRef: ChangeDetectorRef,) {}

  ngOnInit() {
    
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      let pageId = params['pageId'];
      if(pageId !== undefined)
      {
        this.sharedService.pages1$.pipe(takeUntil(this.destroy$)).subscribe((pages) => {
        })
      }
    });
    this.applicationMetaData = this.sharedService.getApplicationDataById();

   this.getDisplayContent();
   this.subjectSubscriptions();
   
  }

  subjectSubscriptions(){
    this.sharedService.onMobileScreenDropSubjectdata$.pipe(takeUntil(this.destroy$)).subscribe((data:any)=>{
      if(data?.onClick){
        this.widgetId=data?.data;
        this.sectionIndex=data?.sectionIndex;
        this.widgetIndex=data?.widgetIndex
        this.selectedWidgetMetaData = data?.widgetMeta;
        this.selectedWidgetTypeConfig = data?.widgetMeta.type; 
        this.selectedColor = data?.widgetMeta?.widgetConfig?.style?.color;
        this.selectedBgColor = data?.widgetMeta?.style?.backgroundColor;
      }
      if(data['isEdit'] && data['stageName']){
        this.stageName = data['stageName'] + ' '
      }
    });
  }

  
  getDisplayContent()
  {
    //This is used to open the subNav and to display the related content

    const sideNavSubscription = this.sharedService.sidenavContentlistSubject$.pipe(takeUntil(this.destroy$)).subscribe((option) => {
      // this.sharedService.onMobileScreenClearData();
      if('' != option.id)
      {
        this.openedContainers = [];
        this.displayedContent = option.id;
      }

      if (option.id == '') {
        this.displaySubNav = false;
      }
      else {
        this.displaySubNav = option.isActive;

      }
     
    });
    this.sideNavSubscription.push(sideNavSubscription)
  }

  showContent(component:string)
  {
    this.displayedContent = component;
    this.openedContainers.push(component);
  }


  // this function is used to navigate back to a previously opened container;
  onBack() {
     this.openedContainers.pop();
    
    if(this.openedContainers.length < 1)
    {
    this.sharedService.setSidenavContentlistOption("",false);
    }else{
      let val = this.openedContainers[this.openedContainers.length - 1];
      this.sharedService.onMobileScreenClearData();
      if(val)
      this.displayedContent = val;
    }
  }



  changePanelState(i:number)
  {
    this.panelStates.forEach((value) => {
      value = false;
    })
    this.panelStates[i] = !this.panelStates[i]
  }


  // Add Component

  applyFilter() {
    this.filteredCategories = [];
    if (this.searchTerm && this.searchTerm != "") {
      this.isFilterApplied = true;
      // Loop through each section in SECTION_META
      CATEGORIES_META_DATA.forEach((category: any) => {

      const filteredItems = category.items.filter((item: any) => {
        return item.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      });

      if (filteredItems.length > 0) {
        this.filteredCategories.push({
          ...category,
          items: filteredItems,
        });
      }
      this.panelStates = this.filteredCategories.map(() => true);
    });
    } else {
      this.isFilterApplied = false;
      this.filteredCategories = this.categoriesList;
      this.panelStates = this.panelStates.map(() => false);
    }
  }
  

  getImageUrl(item:any)
  {
    let path = '../assets/images/save_mob_icons/'+item.image+'.svg';
    return path;
  }

  getPageImageUrl(item:any)
  {
    let path = '../assets/images/save_mob_icons/'+item.icon+'.svg';
    return path;
  }

  onDragStart(event: DragEvent,item:SECTION | WIDGET): void {
    event.dataTransfer!.setData('text/plain', JSON.stringify(item));
    this.sharedService.setDisplayRestrictedArea(true);
  }

  onDragEnd(event: DragEvent): void {

    if (!event.dataTransfer!.dropEffect) {
    }
    this.sharedService.setDisplayRestrictedArea(false);
  }

  ngOnDestroy() {
    this.sideNavSubscription.forEach((sub) => {
      sub.unsubscribe();
    });
    this.destroy$.next();
    this.destroy$.complete();
  }

  //#region  form section  widgets functionality

  //#endregion
}
